export const accountQueryKeys = {
  demoDataStatus: (accountId: string) => ["demoDataStatus", accountId] as const,

  /** Dashboard license banner; keep key stable for cache compatibility. */
  licenseNotice: () => ["dashboard", "license-notice"] as const,

  list: (
    page: number,
    pageSize: number,
    sortBy: string | undefined,
    sortDirection: "asc" | "desc"
  ) => ["accounts", page, pageSize, sortBy ?? null, sortDirection] as const,

  /** Invalidates all paginated account list queries */
  listPrefix: () => ["accounts"] as const,

  detail: (id: string | undefined) => ["account", id] as const,

  /** Prefix for all account-scoped caches (matches `["account", ...]`) */
  accountPrefix: () => ["account"] as const,

  /** Current tenant “my account” (settings license card, GraphQL myAccounts) */
  myAccount: () => ["myAccount"] as const,
};
